import { XHRAuthorizedClient } from '@/remote/client';
import { ENDPOINTS } from '@/remote/endpoints';
import type { Site, SiteApiResponse, UpdateSiteData } from '@/types/site';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { QUERY_KEYS } from '../query-key';

interface UpdateSiteParams {
  siteId: string;
  siteData: UpdateSiteData;
}

export const useUpdateSite = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: [QUERY_KEYS.sites.updateSite],
    mutationFn: async ({
      siteId,
      siteData,
    }: UpdateSiteParams): Promise<Site> => {
      const response = await XHRAuthorizedClient.put<SiteApiResponse>(
        ENDPOINTS.sites.update(siteId),
        siteData
      );
      return response.data.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries();
    },
    onError: (error) => {
      console.error('사이트 수정 오류:', error);
    },
  });
};
